import React from "react";
import { Row, Col, Card, Typography, Skeleton } from "antd";
import { Title, ChartCard } from "components/common";
import { LineChart, BarChart } from "components/charts";
import { getTimeDateString } from "utils/date";
import styles from "./DashboardPerformanceCharts.module.less";

const { Text } = Typography;

const ChartsSkeleton = () => (
  <Card className={styles.sectionCard}>
    <div className={styles.sectionHeader}>
      <Skeleton.Input active size="small" className={styles.skeletonTitle} />
    </div>
    <Row gutter={[16, 16]}>
      <Col xs={24} lg={12}>
        <div className={styles.skeletonChartCard}>
          <Skeleton.Input active size="small" className={styles.skeletonChartTitle} />
          <Skeleton active title={false} paragraph={{ rows: 6 }} className={styles.skeletonChartArea} />
        </div>
      </Col>
      <Col xs={24} lg={12}>
        <div className={styles.skeletonChartCard}>
          <Skeleton.Input active size="small" className={styles.skeletonChartTitle} />
          <Skeleton active title={false} paragraph={{ rows: 6 }} className={styles.skeletonChartArea} />
        </div>
      </Col>
    </Row>
  </Card>
);

const DashboardPerformanceCharts = ({
  accuracyTrend = [],
  specialityPerformance = {},
  loading,
  isFetching,
}) => {
  const accuracyTrendChartData = (accuracyTrend || []).map((item) => ({
    date: getTimeDateString(item.date, false, true) || item.date,
    accuracy: parseFloat(item.accuracy) ?? 0,
  }));

  const specialtyChartData = Object.entries(specialityPerformance || {}).flatMap(
    ([specialty, obj]) => [
      { specialty, type: "Correct", value: obj?.correct ?? 0 },
      { specialty, type: "Incorrect", value: obj?.incorrect ?? 0 },
    ]
  );

  if (loading) return <ChartsSkeleton />;

  return (
    <Card className={styles.sectionCard}>
      <div className={styles.cardContentWrap}>
        <div className={styles.sectionHeader}>
          <Title level={5} className={styles.sectionTitle}>
            Performance Trends
          </Title>
        </div>
        <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <ChartCard title="Accuracy Trend Over Time">
            {accuracyTrendChartData.length > 0 ? (
              <LineChart
                data={accuracyTrendChartData}
                xField="date"
                yField="accuracy"
                xAxis={{ title: { text: "Time period" } }}
                yAxis={{
                  title: { text: "Accuracy %" },
                  min: 0,
                  max: 100,
                }}
              />
            ) : (
              <div className={styles.emptyChart}>No accuracy data yet</div>
            )}
          </ChartCard>
        </Col>
        <Col xs={24} lg={12}>
          <ChartCard title="Performance by Specialty">
            {specialtyChartData.length > 0 ? (
              <BarChart
                isStacked
                data={specialtyChartData}
                xField="specialty"
                yField="value"
                seriesField="type"
                color={["#52c41a", "#ff4d4f"]}
                xAxis={{ title: { text: "Specialty" } }}
                yAxis={{
                  title: { text: "Questions (Correct / Incorrect)" },
                }}
              />
            ) : (
              <div className={styles.emptyChart}>
                No specialty performance data yet
              </div>
            )}
          </ChartCard>
        </Col>
      </Row>
        {isFetching && <div className={styles.shimmerOverlay} />}
      </div>
    </Card>
  );
};

export default DashboardPerformanceCharts;
